import { Logger } from "@spawn/common";
import { RevealNetworkState, RevealTarget } from "@spawn/reveal";
import { BaseSymbolTypes, symbolTypeCubeIds } from "../services/symbolService";
import { deepClone } from "../utils/object";

// HACK: the grgs backend of these games is not consistent with the response structure from Frooty Troupe, but will be fixed on all other games
export const invertNudgingOffsets = (offsets: number[]): number[] => offsets.map((offset) => (offset === 0 ? 0 : -offset));

// HACK: grgs sends CALAVERA_X1, CALAVERA_X2, etc. as symbols, but we need to map them to the golden bonus symbols
export const mapCalaverasToGoldenBonus = (x: RevealNetworkState): RevealNetworkState => ({
	...x,
	symbols: (x.symbols || [])?.map((revealTarget) => ({
		...revealTarget,
		symbol: symbolTypeCubeIds.get(revealTarget.symbol) ?? revealTarget.symbol,
	})),
});

export const reelHasFlowers = (reel: string[]): boolean => reel.includes(BaseSymbolTypes.Mystery);

export const getReelsAfterReveal = (reels: string[][], reveals: RevealTarget[]): string[][] => {
	const finalReels = deepClone(reels);

	for (const reveal of reveals) {
		finalReels[reveal.position.x][reveal.position.y + 1] = reveal.symbol;
	}

	return finalReels;
};

export const printReels = (prefix: string, reels: string[][], mapper?: (symbol: unknown) => string): void => {
	Logger.log(
		`${prefix}--------------------------------
${reels.map((reel) => reel.map(mapper ?? ((x) => x)).join(", ")).join("\n")}
${prefix}--------------------------------`
	);
};
